export default "/institutions/picpay.svg";